<div class="modern-admin-page">
  <!-- Page Header -->
  <div class="page-header-card">
    <div class="header-content">
      <div class="page-title-section">
        <h1 class="page-title bangla-heading">এ্যাসেসমেন্ট তালিকা</h1>
        <p class="page-subtitle">সমস্ত এ্যাসেসমেন্ট দেখুন এবং পরিচালনা করুন</p>
      </div>
      <div class="page-actions">
        <button type="button" routerLink="/admin/assessment-create" class="btn-primary-modern">
          <i class="fas fa-plus"></i>
          নতুন এ্যাসেসমেন্ট
        </button>
        <button type="button" routerLink="/admin/multiple-assessment-create" class="btn-secondary-modern">
          <i class="fas fa-layer-group"></i>
          একাধিক এ্যাসেসমেন্ট
        </button>
      </div>
    </div>
  </div>

  <!-- Filters and Actions Section -->
  <div class="content-card slide-up">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-filter"></i>
        ফিল্টার এবং অ্যাকশন
      </h3>
    </div>
    
    <div class="card-body">
      <!-- Filter Controls -->
      <div class="filters-section">
        <div class="filter-row">
          <div class="filter-group">
            <label class="filter-label bangla-label">পৃষ্ঠা সাইজ:</label>
            <select (change)="changePageSize($event)" class="form-control-modern">
              <option *ngFor="let size of pageSizes" [value]="size">
                {{ size }}
              </option>
            </select>
          </div>
          
          <div class="filter-group">
            <label class="filter-label bangla-label">ওয়ার্ড ফিল্টার:</label>
            <select (change)="filterByWard($event)" class="form-control-modern">
              <option value="">সব ওয়ার্ড</option>
              <option *ngFor="let ward of wards" [value]="ward.ward_number">
                {{ ward.ward_number }} - {{ ward.ward_name }}
              </option>
            </select>
          </div>

          <div class="filter-group">
            <label class="filter-label bangla-label">অনুসন্ধান:</label>
            <input 
              type="text" 
              placeholder="সব ক্ষেত্রে অনুসন্ধান করুন..." 
              class="form-control-modern" 
              (input)="performFullTextSearch($event)"
            >
          </div>

          <div class="filter-group">
            <button class="btn-outline-modern" (click)="clearFilters()">
              <i class="fas fa-times"></i>
              ফিল্টার সাফ করুন
            </button>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <button
          [useExistingCss]="true"
          ngxPrint
          printSectionId="hiddenHoldingCardsDiv"
          class="btn-secondary-modern"
        >
          <i class="fas fa-print"></i>
          হোল্ডিং কার্ড প্রিন্ট
        </button>
        
        <button
          (click)="exportTableToExcel()"
          class="btn-secondary-modern"
        >
          <i class="fas fa-file-excel"></i>
          এক্সেল এক্সপোর্ট
        </button>
        
        <button
          class="btn-secondary-modern"
          [useExistingCss]="true"
          ngxPrint
          printSectionId="hiddenAssessmentsDiv"
        >
          <i class="fas fa-print"></i>
          এ্যাসেসমেন্ট প্রিন্ট
        </button>
        
        <button
          ngxPrint
          [useExistingCss]="true"
          printSectionId="hiddenUpCardsDiv"
          class="btn-secondary-modern"
        >
          <i class="fas fa-id-card"></i>
          ইউপি স্মার্ট কার্ড প্রিন্ট
        </button>
      </div>
    </div>
  </div>

  <!-- Data Table Section -->
  <div class="content-card slide-up">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-table"></i>
        এ্যাসেসমেন্ট ডেটা
      </h3>
      <div class="card-actions">
        <span class="data-count">
          মোট <strong>{{totalItems}}</strong> টি রেকর্ড
        </span>
      </div>
    </div>
    
    <div class="card-body">
      <!-- Column Filters -->
      <div class="column-filters">
        <div class="filter-inputs">
          <input
            type="text"
            #holdingNumberFilter
            (input)="filterData($event, 'holding_number')"
            placeholder="হোল্ডিং নং"
            class="filter-input"
          />
          <input
            type="text"
            #nameFilter
            (input)="filterData($event, 'name')"
            placeholder="নাম"
            class="filter-input"
          />
          <input
            type="text"
            #guardianNameFilter
            (input)="filterData($event, 'gurdian_name')"
            placeholder="পিতা/স্বামী"
            class="filter-input"
          />
          <input
            type="text"
            #wardNumberFilter
            (input)="filterData($event, 'ward_number')"
            placeholder="ওয়ার্ড নং"
            class="filter-input"
          />
          <input
            type="text"
            #mobileNumberFilter
            (input)="filterData($event, 'mobile_number')"
            placeholder="মোবাইল"
            class="filter-input"
          />
          <input
            type="text"
            #khanarDhoronFilter
            (input)="filterData($event, 'khanar_dhoron')"
            placeholder="খানার ধরণ"
            class="filter-input"
          />
          <input
            type="text"
            #gramOrRastaFilter
            (input)="filterData($event, 'gram_or_rasta')"
            placeholder="গ্রাম/রাস্তা"
            class="filter-input"
          />
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-state">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
          <p class="bangla-text">ডেটা লোড হচ্ছে...</p>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && (!paginatedData || paginatedData.length === 0)" class="empty-state">
        <div class="empty-icon">
          <i class="fas fa-file-alt"></i>
        </div>
        <h3 class="bangla-title">কোন এ্যাসেসমেন্ট পাওয়া যায়নি</h3>
        <p class="bangla-text">এখনো কোন এ্যাসেসমেন্ট তৈরি করা হয়নি অথবা আপনার ফিল্টার অনুযায়ী কোন ডেটা পাওয়া যায়নি।</p>
        <button type="button" routerLink="/admin/assessment-create" class="btn-primary-modern">
          <i class="fas fa-plus"></i>
          প্রথম এ্যাসেসমেন্ট তৈরি করুন
        </button>
      </div>

      <!-- Data Table -->
      <div *ngIf="!isLoading && paginatedData && paginatedData.length > 0" class="table-responsive">
        <table class="table-modern" role="table" aria-label="এ্যাসেসমেন্ট তালিকা">
          <thead>
            <tr role="row">
              <th class="actions-column" role="columnheader">অ্যাকশন</th>
              <th class="sortable-header" (click)="sortData('holding_number')" 
                  role="columnheader" 
                  [attr.aria-sort]="currentSortColumn === 'holding_number' ? (currentSortDirection === 'asc' ? 'ascending' : 'descending') : 'none'"
                  tabindex="0"
                  (keydown.enter)="sortData('holding_number')"
                  (keydown.space)="sortData('holding_number')"
                  [attr.aria-label]="'হোল্ডিং নং কলাম, ' + (currentSortColumn === 'holding_number' ? (currentSortDirection === 'asc' ? 'ক্রমহ্রাসমান' : 'ক্রমবর্ধমান') + ' সাজানো' : 'সাজানো যাবে')">
                <span class="bangla-label">হোল্ডিং নং</span>
                <i *ngIf="currentSortColumn === 'holding_number'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th class="sortable-header" (click)="sortData('name')">
                <span class="bangla-label">নাম</span>
                <i *ngIf="currentSortColumn === 'name'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th class="sortable-header" (click)="sortData('gurdian_name')">
                <span class="bangla-label">পিতা/স্বামী</span>
                <i *ngIf="currentSortColumn === 'gurdian_name'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th class="sortable-header" (click)="sortData('ward_number')">
                <span class="bangla-label">ওয়ার্ড নং</span>
                <i *ngIf="currentSortColumn === 'ward_number'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th class="sortable-header" (click)="sortData('mobile_number')">
                <span class="bangla-label">মোবাইল</span>
                <i *ngIf="currentSortColumn === 'mobile_number'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th class="sortable-header" (click)="sortData('khanar_dhoron')">
                <span class="bangla-label">খানার ধরণ</span>
                <i *ngIf="currentSortColumn === 'khanar_dhoron'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th class="sortable-header" (click)="sortData('gram_or_rasta')">
                <span class="bangla-label">গ্রাম/রাস্তা</span>
                <i *ngIf="currentSortColumn === 'gram_or_rasta'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let assessment of paginatedData; let i = index" [class.table-striped]="i % 2 === 0">
              <td class="actions-cell">
                <div class="action-buttons-cell">
                  <button
                    title="আইডি কার্ড প্রিন্ট করুন"
                    class="btn-action-sm"
                    (click)="navigateToIdCardPage(assessment.id)"
                    [attr.aria-label]="'আইডি কার্ড প্রিন্ট করুন ' + assessment.name + ' এর জন্য'"
                  >
                    <i class="far fa-id-card" aria-hidden="true"></i>
                  </button>
                  <button
                    title="হোল্ডিং কার্ড প্রিন্ট করুন"
                    class="btn-action-sm"
                    (click)="navigateToHoldingCardPage(assessment.id)"
                    [attr.aria-label]="'হোল্ডিং কার্ড প্রিন্ট করুন ' + assessment.name + ' এর জন্য'"
                  >
                    <i class="far fa-credit-card" aria-hidden="true"></i>
                  </button>
                  <button
                    title="কর আদায় করুন"
                    class="btn-action-sm"
                    (click)="navigateToUserStatus(assessment.qr_code)"
                    [attr.aria-label]="'কর আদায় করুন ' + assessment.name + ' এর জন্য'"
                  >
                    <i class="fas fa-money-bill-wave" aria-hidden="true"></i>
                  </button>
                  <button
                    title="সম্পাদনা করুন"
                    class="btn-action-sm btn-edit"
                    (click)="navigateToEditAssesmentPage(assessment.id)"
                    [attr.aria-label]="'সম্পাদনা করুন ' + assessment.name + ' এর তথ্য'"
                  >
                    <i class="far fa-edit" aria-hidden="true"></i>
                  </button>
                  <button
                    title="মুছে ফেলুন"
                    class="btn-action-sm btn-delete"
                    (click)="deleteAssesment(assessment.id)"
                    [attr.aria-label]="'মুছে ফেলুন ' + assessment.name + ' এর তথ্য'"
                  >
                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                  </button>
                  <button
                    title="QR কোড স্ক্যান করুন"
                    class="btn-action-sm"
                    (click)="navigateToScannedPage(assessment.qr_code)"
                    [attr.aria-label]="'QR কোড স্ক্যান করুন ' + assessment.name + ' এর জন্য'"
                  >
                    <i class="fas fa-qrcode" aria-hidden="true"></i>
                  </button>
                  <button
                    title="QR কোড কপি করুন"
                    class="btn-action-sm"
                    (click)="copyQrCode(assessment.qr_code)"
                    [attr.aria-label]="'QR কোড কপি করুন ' + assessment.name + ' এর জন্য'"
                  >
                    <i class="fas fa-copy" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
              <td class="bangla-text">{{ assessment.holding_number }}</td>
              <td class="bangla-text">{{ assessment.name }}</td>
              <td class="bangla-text">{{ assessment.gurdian_name }}</td>
              <td class="bangla-text">
                {{
                  unionDomain.convertEnglishHoldingNumberToBanglaHoldingNumber(
                    assessment.ward_number.toString()
                  )
                }}
              </td>
              <td class="bangla-text">{{ assessment.mobile_number }}</td>
              <td class="bangla-text">
                {{
                  unionDomain.khanarDhoronNumberToKhanarDhoronName(
                    assessment.khanar_dhoron
                  )
                }}
              </td>
              <td class="bangla-text">{{ assessment.gram_or_rasta }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Info -->
      <div class="pagination-info">
        <span class="info-badge">
          {{ itemsPerPage === 'All' ? 'সব ' + totalItems + ' টি আইটেম দেখানো হচ্ছে' : 
            'দেখানো হচ্ছে ' + ((currentPage - 1) * (+itemsPerPage) + 1) + ' - ' +
            (currentPage * (+itemsPerPage) > totalItems ? totalItems : currentPage * (+itemsPerPage)) +
            ' এর মধ্যে ' + totalItems + ' টি' }}
        </span>
      </div>

      <!-- Pagination Controls -->
      <nav *ngIf="itemsPerPage !== 'All'" class="pagination-nav">
        <div class="pagination-modern">
          <button class="pagination-btn" [disabled]="currentPage === 1" (click)="changePage(1)">
            <i class="fas fa-angle-double-left"></i>
            প্রথম
          </button>
          <button class="pagination-btn" [disabled]="currentPage === 1" (click)="changePage(currentPage - 1)">
            <i class="fas fa-angle-left"></i>
            পূর্ববর্তী
          </button>
          
          <div class="page-numbers">
            <button
              class="page-number"
              *ngFor="let page of getPaginationPages()"
              [class.active]="page === currentPage"
              (click)="changePage(page)"
            >
              {{ page }}
            </button>
          </div>
          
          <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="changePage(currentPage + 1)">
            পরবর্তী
            <i class="fas fa-angle-right"></i>
          </button>
          <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="changePage(totalPages)">
            শেষ
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </nav>
    </div>
  </div>
</div>

<!-- Hidden Print Sections - Keep existing functionality -->
<div hidden>
  <div id="hiddenUpCardsDiv" class="card border-0 rounded-0 h-10">
    <div class="card-body">
      <div>
        <div *ngFor="let assessment of paginatedData" class="up-card-container">
          <img
            class="up-card-image-class"
            [src]="upCardBanner"
            alt="UP Card"
          />
          <div class="up-card-name">{{ assessment.name }}</div>
          <div class="up-card-holding-no">{{ assessment.holding_number }}</div>
          <div class="up-card-ward-no">
            {{
              unionDomain.convertEnglishHoldingNumberToBanglaHoldingNumber(
                assessment.ward_number.toString()
              )
            }}
          </div>
          <div class="up-card-village">{{ assessment.gram_or_rasta }}</div>
          <div class="up-card-qr-code">
            <qrcode
              [elementType]="'svg'"
              [qrdata]="unionDomain.qrCodeInitialString + assessment.qr_code"
              [width]="60"
              [errorCorrectionLevel]="'L'"
            ></qrcode>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div hidden>
  <div class="card border-0 rounded-0 h-full">
    <div class="card-body">
      <div id="hiddenHoldingCardsDiv">
        <div
          *ngFor="let assessment of paginatedData"
          class="holding-card-container"
        >
          <img
            class="holding-card-image-class"
            [src]="holdingCardBanner"
            alt="Holding Card"
          />
          <div class="holding-card-name">{{ assessment.name }}</div>
          <div class="holding-card-holding-no">
            {{ assessment.holding_number }}
          </div>
          <div class="holding-card-ward-no">
            {{
              unionDomain.convertEnglishHoldingNumberToBanglaHoldingNumber(
                assessment.ward_number.toString()
              )
            }}
          </div>
          <div class="holding-card-village">{{ assessment.gram_or_rasta }}</div>
          <div class="holding-card-qr-code">
            <qrcode
              [elementType]="'svg'"
              [qrdata]="unionDomain.qrCodeInitialString + assessment.qr_code"
              [width]="170"
              [errorCorrectionLevel]="'L'"
            ></qrcode>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div hidden id="hiddenAssessmentsDiv" class="specific-div">
  <div id="hiddenAssessmentsDiv2" class="card border-0 rounded-0 h-10">
    <div class="card-body">
      <table id="tableId" class="">
        <thead>
          <tr>
            <td colspan="12" class="p-4">
              <div class="table-heading">
                {{ unionDomain.unionData.union_name }}
              </div>
              <br />{{ unionDomain.unionData.upozilla_name }} ,
              {{ unionDomain.unionData.zilla_name }}
            </td>
          </tr>
          <tr>
            <th class="col">হোল্ডিং</th>
            <th class="col">নাম</th>
            <th class="col">পিতা/স্বামী</th>
            <th class="col">ওয়ার্ড নং</th>
            <th class="col">ঠিকানা</th>
            <th class="col">মোবাইল</th>
            <th class="col">পেশা</th>
            <th class="col">বাড়ির ধরণ</th>
            <th class="col">বার্ষিক মূল্যমান</th>
            <th class="col">ধার্য্যকৃত ট্যাক্স</th>
            <th class="col">কিউআর কোড</th>
          </tr>
        </thead>
        <tbody>
          <tr class="py-2" *ngFor="let assessment of paginatedData">
            <td>{{ assessment.holding_number }}</td>
            <td>{{ assessment.name }}</td>
            <td>{{ assessment.gurdian_name }}</td>
            <td>
              {{
                unionDomain.convertEnglishHoldingNumberToBanglaHoldingNumber(
                  assessment.ward_number.toString()
                )
              }}
            </td>
            <td>{{ assessment.gram_or_rasta }}</td>
            <td>{{ assessment.mobile_number }}</td>
            <td>{{ unionDomain.peshaNumberToPeshaName(assessment.pesha) }}</td>
            <td>
              {{
                unionDomain.khanarDhoronNumberToKhanarDhoronName(
                  assessment.khanar_dhoron
                )
              }}
            </td>
            <td>
              {{
                unionDomain.khanarDhoronNumberToKhanarMulloAndTax(
                  assessment.khanar_dhoron
                ).khanarMullo
              }}
            </td>
            <td>
              {{
                unionDomain.khanarDhoronNumberToKhanarMulloAndTax(
                  assessment.khanar_dhoron
                ).khanarTax
              }}
            </td>
            <td class="py-2">
              <qrcode
                [elementType]="'img'"
                [qrdata]="unionDomain.qrCodeInitialString + assessment.qr_code"
                [width]="80"
                [errorCorrectionLevel]="'L'"
              ></qrcode>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
